// extracted by mini-css-extract-plugin
module.exports = {"prepeuWrapper":"prepeu_prepeuWrapper__Vu8o_","prepeuMarato":"prepeu_prepeuMarato__a4xv_","peuMaratoItem":"prepeu_peuMaratoItem__WJ_14","icona":"prepeu_icona__CmqMO"};